import { DatoCmsAllLocalesForDatoCmsArticleSlug, DatoCmsSlugsConfiguration } from "../../../../graphql-types"

/**
 * Format a date to "MON. DD, YYYY"
 * @param date
 */
export const dateFormat = (date: string, locale: string): string => {
  const newDate = new Date(date)
  const day = newDate.getDate()
  const month = newDate.toLocaleString(locale === "fr" ? "fr-FR" : "en-GB", { month: "short" })
  const year = newDate.getFullYear()

  if (locale === "fr") {
    return `${day} ${month.toUpperCase()} ${year}`
  }
  return `${month.toUpperCase()}. ${day}, ${year}`
}

/**
 * Get the offset of a given DOM element relative to the document.
 * Useful when trying to get the position of the element on the page.
 *
 * @param element
 */
export const elementOffset = (element: HTMLElement | Element) => {
  let rect = element && element.getBoundingClientRect(),
    scrollLeft = window.scrollX || document.documentElement.scrollLeft,
    scrollTop = window.scrollY || document.documentElement.scrollTop
  return rect ? { top: rect.top + scrollTop, left: rect.left + scrollLeft, bottom: rect.bottom + scrollTop } : null
}

/**
 * Apply style transformation on a given item and speed
 *
 * @param item
 * @param speed
 */
export const transformItem = (item: HTMLElement | Element, speed: number) => {
  if (!item) return

  const itemHTMLElement = item as HTMLElement
  setTimeout(() => {
    itemHTMLElement.style.transform = "translateY(0)"
    itemHTMLElement.style.opacity = "1"
  }, speed)
}

export const transformItemWithoutTransition = (item: HTMLElement | Element) => {
  if (!item) return

  const itemHTMLElement = item as HTMLElement
  itemHTMLElement.style.transform = "translateY(0px)"
  itemHTMLElement.style.opacity = "1"
  itemHTMLElement.style.transition = "all 0ms cubic-bezier(0.25, 1, 0.5, 1)"
}

/**
 * Change page language
 *
 * @param currentRoute the current route (ex: /projects-news-insights)
 * @param slugs all the slugs of the website all languages included
 * @param newLocale the new language locale
 * @param defaultLocale the default locale of the page
 */
export const changeLanguage = (
  currentRoute: string,
  slugs: DatoCmsSlugsConfiguration,
  allSlugLocales: [DatoCmsAllLocalesForDatoCmsArticleSlug],
  newLocale: string,
  defaultLocale: string
) => {
  let relatedSlug = ""

  for (const key in slugs) {
    if (Array.isArray(slugs[key])) {
      const isRelatedSlug = slugs[key].filter(slug => {
        return slug.value === currentRoute
      })
      if (isRelatedSlug.length > 0) {
        const slugByLocale = slugs[key].filter(slug => slug.locale === newLocale)
        if (slugByLocale.length > 0) {
          relatedSlug = slugByLocale[0].value
        }
      }
    }
  }

  relatedSlug = newLocale === defaultLocale ? `/${relatedSlug}` : `/${newLocale}/${relatedSlug}`

  if (allSlugLocales) {
    const articleSlug = allSlugLocales.filter(slug => slug.locale === newLocale)

    if (articleSlug && articleSlug[0]) {
      relatedSlug += `/${articleSlug[0].value}`
    }
  }

  return relatedSlug
}
